<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <h5><strong>REPORTE GENERAL DE STOCK DE INSUMOS</strong></h5>

        <!-- SECCIÓN DE FILTROS SUPERIOR -->
        <div class="col-12 p-fondo mb-3">
          <div class="p-fluid formgrid grid">
            
            <!-- Sucursal -->
            <div class="field col-12 md:col-3">
              <span><strong>SUCURSAL: </strong></span>
              <Dropdown
                v-model="sucursalSelected"
                :options="sucursales"
                optionLabel="nombre"
                optionValue="id"
                placeholder="Seleccione Sucursal"
              />
            </div>

            <!-- Clasificación de Insumo -->
            <div class="field col-12 md:col-3">
              <span><strong>CLASIFICACIÓN: </strong></span>
              <Dropdown
                v-model="clasificacionSelected"
                :options="clasificaciones"
                optionLabel="nombre"
                optionValue="id"
              />
            </div>

            <!-- Estado de Stock -->
            <div class="field col-12 md:col-3">
              <span><strong>DISPONIBILIDAD: </strong></span>
              <Dropdown
                v-model="estadoSelected"
                :options="estadosStock"
                optionLabel="nombre"
                optionValue="id"
              />
            </div>

            <!-- Botón Aplicar Filtros -->
            <div class="field col-12 md:col-3 flex align-items-end">
              <Button
                label="APLICAR FILTROS"
                icon="pi pi-search"
                class="p-button-info w-full"
                :loading="enviando"
                @click="cargarDatos(1)"
              />
            </div>

          </div>
        </div>

        <!-- TABLA DE DATOS -->
        <DataTable
          ref="dt_insumos"
          :value="insumos"
          responsiveLayout="scroll"
          :loading="enviando"
          class="p-datatable-sm"
          stripedRows
          showGridlines
        >
          <!-- HEADER: Búsqueda y Botones de Exportación -->
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-center">
              
              <!-- Buscador y Botones de Acción / Descarga -->
              <div class="flex align-items-center mt-2 md:mt-0 flex-wrap gap-2">
                <span class="block p-input-icon-left">                  
                  <InputText
                    v-model="textoBusqueda"
                    placeholder="Buscar por código o insumo..."
                    class="w-full md:w-20rem"
                    @keyup.enter="cargarDatos(1)"
                  />
                </span>

                <Button
                  label="PDF Stock"
                  icon="pi pi-file-pdf"
                  class="p-button-outlined p-button-danger"
                  :loading="generando_pdf"
                  @click="generarPDF()"
                />

                <Button
                  label="EXCEL Exportar"
                  icon="pi pi-file-excel"
                  class="p-button-outlined p-button-success"
                  :loading="exportando"
                  @click="exportarExcel()"
                />
              </div>

            </div>
          </template>

          <template #loading>
            <div class="text-center p-4">
              <ProgressSpinner style="width: 50px; height: 50px;" strokeWidth="4" />
            </div>
          </template>

          <template #empty>
            <div class="text-center p-3">
              No se encontraron registros de insumos para los filtros seleccionados.
            </div>
          </template>

          <!-- COLUMNAS -->
          <Column field="codigo" header="CÓDIGO" style="width: 8%">
            <template #body="slotProps">
              {{ slotProps.data.codigo || 'S/C' }}
            </template>
          </Column>

          <Column field="nombre" header="INSUMO / DESCRIPCIÓN" style="width: 23%"></Column>

          <Column header="TIPO DE INSUMO" style="width: 13%">
            <template #body="slotProps">
              <span
                :class="slotProps.data.es_producido ? 'text-primary font-bold' : 'text-color font-normal'"
              >
                {{ slotProps.data.es_producido ? 'PRODUCIDO / PORC.' : 'MATERIA PRIMA (COMPRA)' }}
              </span>
            </template>
          </Column>

          <Column field="stock_actual" header="STOCK / U. DISPONIBLE" style="width: 10%" class="text-right font-bold">
            <template #body="slotProps">
              {{ slotProps.data.stock_actual }}
            </template>
          </Column>

          <Column field="unidad_medida" header="U. MEDIDA" style="width: 7%">
            <template #body="slotProps">
              <span class="p-tag p-tag-info">{{ slotProps.data.unidad_medida }}</span>
            </template>
          </Column>

          <!-- COSTO DE COMPRA BASE (Kg o Pieza) -->
          <Column field="costo_unitario" header="COSTO BASE (BS)" style="width: 10%" class="text-right">
            <template #body="slotProps">
              Bs {{ slotProps.data.costo_unitario_format || Number(slotProps.data.costo_unitario || 0).toFixed(2) }}
            </template>
          </Column>

          <!-- 1. COSTO POR GRAMAJE / UNIDAD MÍNIMA -->
          <Column field="costo_por_gramaje" header="COSTO X G/U" style="width: 11%" class="text-right">
            <template #body="slotProps">
              <span class="font-medium">Bs {{ slotProps.data.costo_gramaje_format || Number(slotProps.data.costo_por_gramaje || 0).toFixed(4) }}</span>
              <small class="text-500 ml-1" v-if="slotProps.data.tipo_costo_gramaje">({{ slotProps.data.tipo_costo_gramaje }})</small>
            </template>
          </Column>

          <!-- 2. TOTAL DE STOCK VALORIZADO -->
          <Column field="total_stock" header="TOTAL (BS)" style="width: 11%" class="text-right">
            <template #body="slotProps">
              <span class="font-bold text-primary">
                Bs {{ slotProps.data.total_stock_format || Number(slotProps.data.total_stock || 0).toFixed(2) }}
              </span>
            </template>
          </Column>

          <Column field="estado_alerta" header="ESTADO" style="width: 7%" class="text-center">
            <template #body="slotProps">
              <span
                class="p-badge"
                :class="slotProps.data.estado_alerta === 'AGOTADO' ? 'p-badge-danger' : 'p-badge-success'"
              >
                {{ slotProps.data.estado_alerta }}
              </span>
            </template>
          </Column>

        </DataTable>

        <!-- PAGINADOR INFERIOR DE LARAVEL -->
        <div class="flex justify-content-between align-items-center mt-3" v-if="totalRegistros > 0">
          <small class="text-500">
            Mostrando del {{ desdeRegistro }} al {{ hastaRegistro }} de {{ totalRegistros }} insumos
          </small>
          <div class="flex align-items-center">
            <Button
              icon="pi pi-chevron-left"
              class="p-button-text p-button-sm mr-2"
              :disabled="paginaActual === 1"
              @click="cargarDatos(paginaActual - 1)"
            />
            <span class="font-bold mr-2">Página {{ paginaActual }} de {{ totalPaginas }}</span>
            <Button
              icon="pi pi-chevron-right"
              class="p-button-text p-button-sm"
              :disabled="paginaActual === totalPaginas"
              @click="cargarDatos(paginaActual + 1)"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import ReporteInsumoService from "@/service/ReporteInsumoService";
// Si tienes un SucursalService úsalo para llenar sucursales, o inyéctalas según tu convención
import SucursalService from "@/service/SucursalService"; 

export default {
  name: "InsumosStock",
  data() {
    return {
      reporteInsumoService: null,
      sucursalService: null,

      insumos: [],
      sucursales: [],
      sucursalSelected: null,

      clasificaciones: [
        { id: "todos", nombre: "TODOS LOS INSUMOS" },
        { id: "producidos", nombre: "SOLO PRODUCIDOS / PORCIONADOS" },
        { id: "comprados", nombre: "SOLO COMPRADOS (MATERIA PRIMA)" },
      ],
      clasificacionSelected: "todos",

      estadosStock: [
        { id: "todos", nombre: "TODOS LOS ESTADOS" },
        { id: "con_stock", nombre: "CON STOCK (> 0)" },
        { id: "agotados", nombre: "AGOTADOS (= 0)" },
      ],
      estadoSelected: "todos",

      textoBusqueda: "",

      // Paginación server-side
      paginaActual: 1,
      totalPaginas: 1,
      totalRegistros: 0,
      desdeRegistro: 0,
      hastaRegistro: 0,
      porPagina: 25,

      // Flags de carga UI
      enviando: false,
      generando_pdf: false,
      exportando: false,
    };
  },
  created() {
    this.reporteInsumoService = new ReporteInsumoService();
    this.sucursalService = new SucursalService();
  },
  mounted() {
    this.cargarSucursales();
  },
  methods: {
    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((response) => {
          this.sucursales = response || [];
          if (this.sucursales.length > 0) {
            this.sucursalSelected = this.sucursales[0].id;
            this.cargarDatos(1);
          }
        })
        .catch((error) => {
          console.error("Error al cargar sucursales:", error);
          this.sucursalSelected = 1;
          this.cargarDatos(1);
        });
    },

    getFiltrosPayload() {
      return {
        sucursal_id: this.sucursalSelected,
        clasificacion: this.clasificacionSelected,
        estado_stock: this.estadoSelected,
        buscar: this.textoBusqueda,
      };
    },

    cargarDatos(pagina = 1) {
      if (!this.sucursalSelected) {
        this.$toast.add({
          severity: "warn",
          summary: "Atención",
          detail: "Seleccione una sucursal para consultar.",
          life: 3000,
        });
        return;
      }

      this.enviando = true;
      this.paginaActual = pagina;

      const params = {
        ...this.getFiltrosPayload(),
        page: this.paginaActual,
        per_page: this.porPagina,
      };

      this.reporteInsumoService
        .getInsumosStock(params)
        .then((response) => {
          this.insumos = response.data || [];
          this.totalRegistros = response.total || 0;
          this.totalPaginas = response.last_page || 1;
          this.desdeRegistro = response.from || 0;
          this.hastaRegistro = response.to || 0;
        })
        .catch((error) => {
          console.error("Error cargando insumos:", error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudo cargar el stock de insumos.",
            life: 3000,
          });
        })
        .finally(() => {
          this.enviando = false;
        });
    },

    exportarExcel() {
      if (this.insumos.length === 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Sin datos",
          detail: "No hay registros disponibles para exportar.",
          life: 3000,
        });
        return;
      }

      this.exportando = true;
      const datos = this.getFiltrosPayload();

      this.reporteInsumoService
        .exportExcel(datos)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Exportación exitosa",
            detail: "El archivo Excel se descargó correctamente.",
            life: 3000,
          });
        })
        .catch((err) => {
          console.error(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Ocurrió un problema al generar el Excel.",
            life: 3000,
          });
        })
        .finally(() => {
          this.exportando = false;
        });
    },

    generarPDF() {
      if (this.insumos.length === 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Sin datos",
          detail: "No hay registros disponibles para imprimir.",
          life: 3000,
        });
        return;
      }

      this.generando_pdf = true;
      const datos = this.getFiltrosPayload();

      this.reporteInsumoService
        .exportPdf(datos)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "PDF Generado",
            detail: "El documento PDF se generó correctamente.",
            life: 3000,
          });
        })
        .catch((err) => {
          console.error(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Ocurrió un problema al abrir el PDF.",
            life: 3000,
          });
        })
        .finally(() => {
          this.generando_pdf = false;
        });
    },
  },
};
</script>

<style scoped>
.p-fondo {
  background-color: var(--surface-card, #ffffff);
  border-radius: 6px;
  padding: 1rem;
  border: 1px solid var(--surface-border, #e9ecef);
}
</style>